/**************************************************
 * Nombre:       Tabla_Prueba_Encabezado
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, useMediaQuery} from "@mui/material";
import {theme} from "../../Tema";
import Tabla_Normal_Soporte from "./SubComponentes/Tablas/Tabla_Normal_Soporte";


const Tabla_Soporte = ({
                           nombre = '',
                           descripcion = '',
                           filtros = [],
                           datosCabecera,
                           data,
                           numeroFilas,
                           filasPagina,
                           filtroEscogido,
                           setFiltroEscogido,
                           cambiarPagina,
                           page,
                           filasPaginaCambia,
                           estado,
                           setEstado,
                           funcionBuscar = null,
                           botones = [],
                           cargando,
                           clickAgregar = null,
                           botonesData = [],
                           clickData

                       }) => {
    const sCell = useMediaQuery(theme.breakpoints.only('xs'))


    const procesarFiltro = (e) => {

        let index = filtros.findIndex((fil) => fil.nombre === e)
        let filtro = filtros[index]
        let dir = filtro.direccion ? filtro.direccion : 'asc'

        setFiltroEscogido({propiedad: filtro.propiedad, direccion: dir})
    }

    return (
        <Grid container size={12}
              sx={{
                  py: 2,
                  px: 3,
                  borderRadius: 2,
                  border: '0.5px solid #EAEAEA',
                  boxShadow: '0px 8px 12px 0px #00000014',

              }}>


            <Grid container size={12}>
                <Tabla_Normal_Soporte
                    data={data}
                    datosCabecera={datosCabecera}
                    numeroFilas={numeroFilas}
                    filasPagina={filasPagina}
                    filtroEscogido={filtroEscogido}
                    setFiltroEscogido={setFiltroEscogido}
                    page={page}
                    cambiarPagina={cambiarPagina}
                    filasPaginaCambia={filasPaginaCambia}
                    estado={estado}
                    setEstado={setEstado}
                    funcionBuscar={funcionBuscar}
                    botones={botones}
                    cargando={cargando}
                    clickAgregar={clickAgregar}
                    botonesData={botonesData}
                    clickData={clickData}

                />
            </Grid>

        </Grid>
    )

}
export default Tabla_Soporte



